import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import girlImg from "../assets/girlwithbook.svg";
import CustomButton from "./custom/CustomButton";
import EnquiryModal from "./custom/EnquiryModal";
import CustomHeading from "./custom/CustomHeading";

export default function GetInTouchFooter({ marginX }) {
  const navigate = useNavigate();
  const [enquiryModal, setEnquiryModal] = useState(false);
  return (
    <div
      className="bg-[#FFC1C1] font-Lato h-[42vh] sm:h-[40vh] max-h-[310px] md:max-h-[330px] lg:max-h-full  lg:h-[48vh] flex flex-row justify-between px-[4%] lg:px-[6%] items-center rounded-3xl sm:rounded-[42px] "
      style={{
        margin: marginX
          ? `${
              window.innerWidth < 450 ? "20px" : "70px"
            } ${marginX} 0px ${marginX}`
          : "100px",
      }}
    >
      <div className="flex flex-col items-start">
        <h1 className="text-[#000000] font-Wonderbar text-[36px] sm:text-[64px] leading-[48px] sm:leading-[80px]">
          Get in <span className="text-[#D31C4F]">Touch</span>
        </h1>
        {/* <CustomHeading
            text={"Get in "}
            textColor="#000000"
            spanText={"Touch"}
            spanTextColor="#d31c4f"
            textSize="64px"
            leading="80px"
            smTextSize="32px"
           
          /> */}

        <p className="font-normal lg:text-xl text-left sm:w-[83%] ">
          If you have any questions regarding admission or our nurturing
          learning environment, let us know so we can connect.
        </p>
        <p className="mt-3 mb-5 font-normal lg:text-xl text-left">
          Give us a call at 📞 7290011862.{" "}
        </p>
        {/* <div className=" text-[#00000] font-Lato text-[20px] font-bold mb-[4px]">
          Book a Visit
        </div>
        <p className="font-normal lg:text-xl text-left sm:w-[83%] ">
          If you do hope to experience the magic of Mother’s Pride, we encourage
          you to fill out a form below so we can further assist you in
          scheduling a visit!
        </p> */}

        <CustomButton
          text={"Contact Us"}
          marginTop="0px"
          marginY="0px"
          paddingY={"13px"}
          bgColor="#EB3434"
          width="180px"
          handleClick={() => setEnquiryModal(true)}
        />
      </div>
      <div>
        <img
          src={girlImg}
          className="sm:flex hidden h-[200px] lg:h-[300px]"
          layout="fit"
          alt=""
        />
      </div>
      {enquiryModal && (
        <EnquiryModal
          enquirySource={"ContactUs"}
          setEnquiryModal={setEnquiryModal}
        />
      )}
    </div>
  );
}
